import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "grid-stack-item-content" }
const _hoisted_2 = {
  key: 0,
  class: "widget-title"
}
const _hoisted_3 = { class: "widget-body" }
const _hoisted_4 = { class: "w-100 h-100 widget-body no-data" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "w-100 has-text-grey is-size-5 has-text-centered has-first-letter-uppercase" }
const _hoisted_7 = { class: "unlocked-background" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "pointed-border center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi has-text-link mdi-drag is-size-1" })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "added-background"
}
const _hoisted_11 = {
  key: 0,
  class: "added"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-check" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "grid-stack-item" }, _ctx.gridStackAttributes), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["box widget-content is-clipped", _ctx.contentClass])
      }, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ], 512 /* NEED_PATCH */), [
          [_vShow, !_ctx.empty || _ctx.editable || _ctx.addable]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            width: "50",
            src: require('@/no-data-icon.svg').default
          }, null, 8 /* PROPS */, _hoisted_5),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('dashboard.widget.not_enough_data')), 1 /* TEXT */)
        ], 512 /* NEED_PATCH */), [
          [_vShow, _ctx.empty && !_ctx.editable && !_ctx.addable]
        ]),
        _createVNode(_Transition, { persisted: "" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_7, _hoisted_9, 512 /* NEED_PATCH */), [
              [_vShow, _ctx.editable]
            ])
          ]),
          _: 1 /* STABLE */
        }),
        (_ctx.addable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.isActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ])
  ], 16 /* FULL_PROPS */))
}